<template>
  <div class="sidecart-wrapper">
    <header v-if="showClose" class="sidecart-header">
      <h2 id="cart-sidebar-title" class="sr-only">Cart</h2>
      <!-- Used to convince GC that this is a cart for cart abandonment feature. -->
      <span style="display: none">Your cart</span>
      <div class="row">
        <div class="columns">
          <div class="cart-count">
            <i class="icon-cart" />
            <span class="count"
              >{{ cart.num_bottles
              }}<span class="sr-only">items in cart</span></span
            >
          </div>
          <button
            v-focus
            aria-label="Close cart"
            class="sidebar-right-close"
            @click="closeCart"
          >
            close
          </button>
          <div v-if="$auth.loggedIn" class="cart-shipping">
            <p>Shipping to {{ $auth.user.state }}</p>
            <a href="/accounts/addresses/">Shipping Elsewhere?</a>
          </div>
        </div>
      </div>
    </header>
    <div class="sidecart-banner">
      <div class="row">
        <div class="columns">
          {{ cart.shipping_message }}
        </div>
      </div>
    </div>
    <CartContent
      :show-empty-link="showClose"
      :toggle-side-cart-on-update="showClose"
      :toggle-side-cart-on-click="showClose"
    />
    <div v-if="cart.lines && cart.lines.length > 0" class="sidecart-total">
      <CartLedger :cart="cart" />
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'CartComponent',
  components: {
    CartLedger: defineAsyncComponent(
      () => import('@/components/Cart/CartLedger'),
    ),
    CartContent: defineAsyncComponent(
      () => import('@/components/Cart/CartContent'),
    ),
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  props: {
    showClose: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      items: [],
      num_bottles: 0,
      applied_refund_credits: [],
      refund_credits_total: 0,
      subtotal: 0,
      total: 0,
      // spinner_url: spinner_url,
      pending_update: false,
      // checkout_url: checkout_url,
      destination: '',
    }
  },
  computed: {
    toggleCart() {
      return this.$store.getters.toggleCart
    },
    ...mapGetters(['cart', 'backdropEnabled']),
  },
  mounted() {
    if (!this.cart || isEqual(this.cart, {})) {
      this.$store.dispatch('getCart')
    }
  },
  methods: {
    updateCartState(data, updateId = null) {},
    closeCart() {
      const focusedElement = this.$el.querySelector(':focus')
      if (focusedElement) focusedElement.blur()
      this.$store.dispatch('toggleCart')
    },
  },
}
</script>
